import React from 'react';
import AddContractAgreementsV1 from './AddContractAgreements.v1';
import AddAgreement from '../AddAgreement';

const AddContractAgreements = props => {
  if (window.config.enableScopeFilters) {
    return <AddAgreement {...props} />;
  }

  return <AddContractAgreementsV1 {...props} />;
};

export default AddContractAgreements;
